import React from 'react';

const TextTruncate = ({ children, length, multiline }) => {
	let cssClasses = "truncate";
	if(multiline) cssClasses += " truncate--multiline";

	const cssStyles = {};
	if(length) cssStyles.maxWidth = length + "ch";
	if(multiline) cssStyles.WebkitLineClamp = multiline;

	return (
		<div className={cssClasses} style={cssStyles}>
			{ children }
		</div>
	);
};

export default TextTruncate;
